export default __webpack_public_path__ + "static/media/2.8a4ea0c8.png";